import CardsList from "./cardsList";

export default CardsList;
